export default __webpack_public_path__ + "static/char-s-29-ja-fda327954a1f5303fa3c5f9a78d14617.webp";